import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FieldArray, Field } from 'redux-form';
import { Link } from 'react-router';
import get from 'lodash/get';
import min from 'lodash/min';
import max from 'lodash/max';
import noop from 'lodash/noop';
import find from 'lodash/find';
import property from 'lodash/property';
import isNull from 'lodash/isNull';
import { connect } from 'react-redux';

import cn from 'classname';

import { getCurrencyIcon } from '../../../../../../../shared/js/get-currency-icon';
import SelectField from '../../../../shared/form-elements/select/field';
import InputField from  '../../../../shared/form-elements/input';
import Filters from '../../../../shared/filters/main';
import Search from '../../../../shared/search/main';

const isRocket = process.env.CPA_ENV === 'rocket';

const Form = (props) => (
	<div className="individual-terms__wrap">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.prepareTermsFormSubmit(data))}>
			<div className="ui-form__element buttons-wrap">
				{ props.can('edit') && (
					<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
				)}
				<Link to='programs/' className="ui-btn ui-btn-cancel">{ props.intl('Cancel') }</Link>
			</div>

			<div className="offers-form-wrap__landings-filters">
				<Search
					form="individualTermsSearchForm"
					initialValues={{ search: '' }}
					action={() => props.fetchIndividualTerms(props.data.id)}
				/>
				<div className="offers-form-wrap__landings-filters-container">
					<Filters {...props} filters={props.individualTermsFilters} {...props.individualTermsFilters} />
				</div>
				<button
					className="ui-btn ui-btn-primary"
					type="button"
					onClick={() => props.fetchIndividualTerms(props.data.id)}
				>
					{props.intl('Apply')}
				</button>
			</div>

			<FieldArray
				name="terms"
				intl={props.intl}
				can={props.can}
				individualTerms={props.individualTerms}
				payoutCurrencies={props.payoutCurrencies}
				individualTermsDeleteAndFetch={props.individualTermsDeleteAndFetch}
				indTermsAffiliatesLookup={props.indTermsAffiliatesLookup}
				locationsLookups={props.locationsLookups}
				offerTargeting={props.formData.offerTargeting}
				listOfActivePanIndex={props.formData.listOfActivePanIndex}
				availableCurrencies={props.formData.availableCurrencies}
				currenciesPanIndexMap={props.formData.currenciesPanIndexMap}
				onShowTargets={props.termsShowTargets}
				onHideTargets={props.termsHideTargets}
				onChangeCurrency={props.changeCurrency}
				onDeleteTerms={props.individualTermsDelete}
				onResetToDefault={props.termsResetToDefault}
				initialValues={props.initialValues}
				nullifyBoostOnSubmit={props.nullifyBoostOnSubmit}
				nullifiedBoosts={props.formData.nullifiedBoosts}
				component={RenderAffiliates}/>

			<div className="ui-form__element buttons-wrap">
				{ props.can('edit') && (
					<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
				)}
				<Link to='programs/' className="ui-btn ui-btn-cancel">{ props.intl('Cancel') }</Link>
			</div>
		</form>
	</div>
);

const RenderAffiliates = ({
	fields,
	intl,
	can,
	individualTerms,
	individualTermsDeleteAndFetch,
	indTermsAffiliatesLookup,
	locationsLookups,
	offerTargeting,
	payoutCurrencies,
	initialValues,
	listOfActivePanIndex,
	onShowTargets,
	onHideTargets,
	onChangeCurrency,
	onDeleteTerms,
	onResetToDefault,
	availableCurrencies,
	currenciesPanIndexMap,
	nullifyBoostOnSubmit,
	nullifiedBoosts
}) => (
	<div className="affiliates-wrap">
		<div
			className="fields-wrap__add"
			onClick={() => fields.push({
				affiliate: [],
				targets: offerTargeting
			})}>
			<span className="fields-wrap__add-title">{intl('Add affiliate')}</span>
		</div>
		{ fields.length > 0 && (
			<div className="affiliates-wrap__list">
				<table className="affiliates-form__table">
					<thead className="affiliates-form__table-head">
						<tr>
							<th className="affiliate">Affiliate</th>
							<th className="geo">Geo</th>
							<th className="payout">Payout</th>
							<th className="currencies"/>
							<th className="actions" />
						</tr>
					</thead>
					<tbody className="affiliates-form__table-body">
						{ (fields.map((parentName, index, fields) => {
							const res = [];
							const affiliate = get(fields.get(index), 'affiliate');
							const affiliateId = affiliate[0] && affiliate[0]['value'] || null;
							const initialValuesField = initialValues.terms;
							const totalGeo = calculateTotalGeo(initialValuesField, offerTargeting, index);
							const shouldShowTarget = listOfActivePanIndex.indexOf(index) > -1;
							const allAffiliateIds = fields.getAll().map(field => field.affiliate[0] && field.affiliate[0].value);
							const isMaster = affiliate[0] && affiliate[0].is_master;

							const minMaxPayout = calculateMinMaxPayout(
								initialValuesField,
								offerTargeting,
								index,
								[currenciesPanIndexMap[index] || 'usd']
							);

							const onToggleTarget = initialValuesField[index] ?
								shouldShowTarget ? onHideTargets: onShowTargets : noop;
							// Affiliate row
							res.push(
								<tr
									className={cn({
										'is-show-target': shouldShowTarget,
										'cursor-pointer': initialValuesField[index]
									})}>
									<td className="affiliate" onClick={e => onToggleTarget(index)}>
										<Field
											name={`${parentName}.affiliate`}
											placeholder={intl('Affiliate')}
											component={SelectField}
											disabled={!!initialValuesField[index]}
											multi={false}
											onChange={ () => onShowTargets(index) }
											showLabel={false}
											options={indTermsAffiliatesLookup.bind(null, allAffiliateIds)} />
									</td>
									<td className="geo" onClick={e => onToggleTarget(index)}><span>{totalGeo}</span></td>
									<td className="payout" onClick={e => onToggleTarget(index)}><span>{minMaxPayout}</span></td>
									<td className="currencies">
										{ <CurrenciesList params={{
											initialValuesField,
											offerTargeting,
											index,
											availableCurrencies,
											currenciesPanIndexMap,
											onChangeCurrency
										}} />}
									</td>
									<td className="actions">
										<span
											className="delete"
											onClick={() => {
												let confirmText = intl('Delete affiliate individual terms%s', '?');
												if (isMaster) {
													confirmText += ' ' + intl('This will delete child individual terms too.');
												}
												if (confirm(confirmText)) {
													!affiliateId ? fields.remove(index) : individualTermsDeleteAndFetch(affiliateId);
												}
											} }/>
										<span className="toggle" onClick={e => onToggleTarget(index)} />
									</td>
								</tr>
							);

							// targeting row
							shouldShowTarget && res.push(
								<FieldArray
									name={`${parentName}.targets`}
									individualTermsDeleteAndFetch={individualTermsDeleteAndFetch}
									locationsLookups={locationsLookups}
									onResetToDefault={onResetToDefault}
									onShowTargets={onShowTargets}
									onDeleteTerms={onDeleteTerms}
									individualTerms={individualTerms}
									payoutCurrencies={payoutCurrencies}
									affiliateId={affiliateId}
									affiliateIndexInList={index}
									intl={intl}
									can={can}
									offerTargeting={offerTargeting}
									nullifyBoostOnSubmit={nullifyBoostOnSubmit}
									nullifiedBoosts={nullifiedBoosts}
									component={RenderTargets}
									isMaster={isMaster}/>
							);

							return res;
						})).reverse() }
					</tbody>
				</table>
			</div>
		) }
	</div>
);

const RenderTargets = ({
	fields,
	intl,
	locationsLookups,
	onShowTargets,
	affiliateIndexInList,
	individualTerms,
	individualTermsDeleteAndFetch,
	can,
	affiliateId,
	offerTargeting,
	onResetToDefault,
	payoutCurrencies,
	onDeleteTerms,
	nullifyBoostOnSubmit,
	nullifiedBoosts,
	isMaster
}) => (
	<tr className="targeting-form__wrap">
		<td colSpan={5}>
			<table className="targeting-form__table">
				<thead className="targeting-form__table-head">
					<tr>
						<th className="location"><span>{intl('Geo')}</span></th>
						<th className="left"><span>{intl('Cap')}</span></th>
						{payoutCurrencies.map((currency, index) =>
							<th className="price" key={index}><span>{intl('Payout, %s', currency)}</span></th>
						)}
						<th />
					</tr>
				</thead>
				<tbody className="targeting-form__table-body">
					{fields.map((parentName, index, fields) => {
						const offerId = get(fields.get(index), 'offer_id');
						const location = get(fields.get(index), 'location_id');
						const locationId = location[0]['value'];

						const shouldDisablePayoutInputs = fields.get(index) &&
						(fields.get(index).status !== 'active' && !isNull(fields.get(index).amount));

						const payoutDirection = getPayoutDirectionClassName(fields.get(index), offerTargeting);

						const wasBoostNullified = !!find(nullifiedBoosts, { offerId, locationId, affiliateId });
						const isCurrentlyBoosted = fields.get(index).boost_till !== null && !wasBoostNullified;

						return (
							<tr key={index}>
								<td className="location">
									<div className={cn('ui-form__element location__field',
										isCurrentlyBoosted ? 'boosted': '')}>
										<Field
											name={`${parentName}.location_id`}
											placeholder=''
											component={SelectField}
											disabled={true}
											searchable={false}
											multi={false}
											showLabel={false}
											options={locationsLookups} />
									</div>
								</td>
								<td className='cap'>
									<div className={cn('ui-form__element')}>
										<Field
											name={`${parentName}.cap`}
											placeholder=''
											component={InputField}
											disabled={!can('offersChangeCap') && !isRocket}
											showLabel={false} />
									</div>
								</td>
								{payoutCurrencies.map((currency, index) =>
									<td className='price last' key={index}>
										<div className={`ui-form__element payout-direction-${payoutDirection[currency]}`}>
											<Field
												name={`${parentName}.${currency}`}
												placeholder=""
												component={InputField}
												onChange={() => nullifyBoostOnSubmit({
													offerId, locationId, affiliateId, defaultCurrency: 'usd',
													payoutPath: parentName, isBoosted: isCurrentlyBoosted
												})}
												showLabel={false}
												disabled={shouldDisablePayoutInputs} />
										</div>
									</td>
								)}
								<td className="actions">
									<span
										className="delete"
										onClick={() => {
											let confirmText = intl('Delete this goe from affiliate', '?');
											if (isMaster) {
												confirmText += ' ' + intl('This will reset child individual terms too.');
											}

											const isSaved = individualTerms.map(property('affiliate_id')).includes(affiliateId);

											if (confirm(confirmText)) {

												if (isSaved)
													onDeleteTerms(affiliateId, locationId).then((isDeleteSuccess) => {
														if (isDeleteSuccess)
															fields.remove(index);
														onShowTargets(affiliateIndexInList);
													});
												else
													fields.remove(index);

											}
										}}/>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</td>
	</tr>
);

const CurrenciesList = ({params}) => {
	const { initialValuesField,  offerTargeting, index,
		availableCurrencies, currenciesPanIndexMap, onChangeCurrency } = params;
	const data = initialValuesField[index] ? initialValuesField[index]['targets'] : offerTargeting;
	let currencies = [];

	availableCurrencies.forEach(currency => {
		data.forEach(entity => {
			if (entity[currency.id] && currencies.indexOf(currency.id) === -1) {
				currencies.push(currency.id);
			}
		});
	});

	currencies = currencies.filter(c => c !== 'rub');

	return (
		<span>
			{ currencies.map((currency, currencyIndex) => {
				let isActive = currencies.length === 1 || (currenciesPanIndexMap[index] ?
					currency === currenciesPanIndexMap[index] : currency === 'rub');

				return (
					<span
						key={currencyIndex}
						className={cn({
							'currency': true,
							'active': isActive
						})}
						onClick={ e => {
							e.preventDefault();
							onChangeCurrency(index, currency);
						}}
					>{getCurrencyIcon(currency)}</span>
				);
			}) }
		</span>
	);
};

Form.propTypes = {
	intl: PropTypes.func,
	can: PropTypes.func,
	indTermsAffiliatesLookup: PropTypes.func,
	locationsLookups: PropTypes.func,
	handleSubmit: PropTypes.func,
	termsFormSubmit: PropTypes.func,
	offerTargeting: PropTypes.array,
	individualTerms: PropTypes.array,
	individualTermsDelete: PropTypes.func,
	individualTermsDeleteAndFetch: PropTypes.func,
	initialValues: PropTypes.object,
	formData: PropTypes.object,
	termsShowTargets: PropTypes.func,
	changeCurrency: PropTypes.func,
	termsHideTargets: PropTypes.func,
	termsResetToDefault: PropTypes.func,
	pristine: PropTypes.bool,
	nullifiedBoosts: PropTypes.array,
	nullifyBoostOnSubmit: PropTypes.func
};

RenderAffiliates.propTypes = {
	fields: PropTypes.object,
	intl: PropTypes.func,
	individualTerms: PropTypes.array,
	indTermsAffiliatesLookup: PropTypes.func,
	individualTermsDeleteAndFetch: PropTypes.func,
	locationsLookups: PropTypes.func,
	offerTargeting: PropTypes.array,
	onDeleteTerms: PropTypes.func,
	initialValues: PropTypes.object,
	onShowTargets: PropTypes.func,
	onHideTargets: PropTypes.func,
	onChangeCurrency: PropTypes.func,
	listOfActivePanIndex: PropTypes.array,
	availableCurrencies: PropTypes.array,
	currenciesPanIndexMap: PropTypes.object,
	onResetToDefault: PropTypes.func,
	nullifiedBoosts: PropTypes.array,
	nullifyBoostOnSubmit: PropTypes.func
};

RenderTargets.propTypes = {
	onShowTargets: PropTypes.func,
	individualTerms: PropTypes.array,
	affiliateIndexInList: PropTypes.number,
	individualTermsDeleteAndFetch: PropTypes.func,
	fields: PropTypes.object,
	intl: PropTypes.func,
	locationsLookups: PropTypes.func,
	affiliateId: PropTypes.number,
	offerTargeting: PropTypes.array,
	onDeleteTerms: PropTypes.func,
	onResetToDefault: PropTypes.func,
	nullifiedBoosts: PropTypes.array,
	nullifyBoostOnSubmit: PropTypes.func,
	isMaster: PropTypes.bool
};

CurrenciesList.propTypes = {
	params: PropTypes.object
};

// functions
const calculateTotalGeo = (initialValue, defaultValue, index) => {
	const data = initialValue[index] ? initialValue[index]['targets'] : defaultValue;
	return data.filter(entity => entity.rub || entity.usd).length;
};

const calculateMinMaxPayout = (initialValue, defaultValue, index, currency = 'rub') => {
	const data = initialValue[index] ? initialValue[index]['targets'] : defaultValue;
	const getAllAmount = data.map(entity => +entity[currency]);
	const minValue = min(getAllAmount) || 0;
	const maxValue = max(getAllAmount) || 0;
	return `${minValue} - ${maxValue}`;
};

const getPayoutDirectionClassName = (field, defaultTargets) => {
	const fieldLocationId = field['location_id'][0]['value'];
	const defaultTargetByLocation = find(
		defaultTargets,
		entity => entity['location_id'][0]['value'] === fieldLocationId
	);

	const calcDirection = currency => {
		const defaultAmount = defaultTargetByLocation && defaultTargetByLocation[currency] ?
			parseInt(defaultTargetByLocation[currency]) : 0;

		const savedAmount = parseInt(field[currency]) || 0;
		return savedAmount > defaultAmount ?
			'more' : savedAmount < defaultAmount ? 'less' : '';
	};

	return {
		rub: calcDirection('rub'),
		eur: calcDirection('eur'),
		usd: calcDirection('usd')
	};
};

const mapStateToProps = (state) => ({
	individualTerms: state.programsEditor.individualTerms,
	isCommentFormVisible: state.programsEditor.individualTermsForm.isCommentFormVisible
});

export default reduxForm({
	form: 'individualTermsForm'
})(connect(mapStateToProps)(Form));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/individual-terms/main.js